import { createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage.js";
import config from '../config.js';

const authContext = createContext();
const ROEN_BACKEND_URL = config.roenBackendURL;

const useProvideAuth = () => {
  const [user, setUser] = useLocalStorage("user", null);
  const navigate = useNavigate();

  const login = async ({ email, password }) => {
    const response = await fetch(`${ROEN_BACKEND_URL}/v1/auth/login`, {
      credentials: 'include',
      headers: { 'Content-type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ email, password })
    });

    if (response.ok) {
      const user = await response.json();
      setUser(user);
      navigate("/");

      return user;
    }

    return false;
  };

  const logout = async () => {
    setUser(null);
    await fetch(`${ROEN_BACKEND_URL}/v1/auth/logout`, {
      credentials: 'include',
      headers: { 'Content-type': 'application/json' },
      method: 'delete'
    });
    navigate("/login", { replace: true });
  };

  return {
    user,
    login,
    logout
  }
};

export const AuthProvider = ({ children }) => {
  const auth = useProvideAuth(); 
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
};

export const useAuth = () => {
  return useContext(authContext);
};


